import { createSlice } from '@reduxjs/toolkit';
import actions from './actions';
import { IState } from './types/reducer';
import { CATEGORY_CODE_NEED_CALL_SHOP } from 'features/Booking/services/constant';
import { IServiceUI } from 'types/service';
import { ICategoryUI } from 'types/category';

const initialState: IState = {
  detail: null,
  successBooking: null,
  transactionDetail: {
    data: null,
    loading: true,
  },
  pureCategories: [],
  categories: [],
  bookingV3Session: {
    loading: true,
    staffs: [],
    staffLoading: false,
    categories: [],
    timeSlots: [],
    timeSlotsLoading: false,
  }
};

export const Slice = createSlice({
  name: 'booking_feature',
  initialState,
  reducers: {
  },
  extraReducers: builder => {
    builder
      .addCase(actions.bookingV3Init.fetch, (state) => {
        state.bookingV3Session.loading = true;
      })
      .addCase(actions.bookingV3Init.success, (state) => {
        state.bookingV3Session.loading = false;
      })
      .addCase(actions.bookingV3Init.fail, (state) => {
        state.bookingV3Session.loading = false;
      })

      .addCase(actions.bookingV3GetStaffsAvailableByDate.fetch, (state) => {
        state.bookingV3Session.staffLoading = true;
        state.bookingV3Session.staffs = [];
      })
      .addCase(actions.bookingV3GetStaffsAvailableByDate.success, (state, { payload }) => {
        state.bookingV3Session.staffLoading = false;
        state.bookingV3Session.staffs = payload;
      })
      .addCase(actions.bookingV3GetStaffsAvailableByDate.fail, (state) => {
        state.bookingV3Session.staffLoading = false;
      })

      .addCase(actions.bookingV3GetCategories.success, (state, { payload }) => {
        state.bookingV3Session.categories = payload;
      })

      .addCase(actions.bookingv3GetAvailableTimeSlotByStaffAndDate.fetch, (state) => {
        state.bookingV3Session.timeSlotsLoading = true;
        state.bookingV3Session.timeSlots = [];
      })
      .addCase(actions.bookingv3GetAvailableTimeSlotByStaffAndDate.success, (state, { payload }) => {
        state.bookingV3Session.timeSlotsLoading = false;
        state.bookingV3Session.timeSlots = payload;
      })
      .addCase(actions.bookingv3GetAvailableTimeSlotByStaffAndDate.fail, (state) => {
        state.bookingV3Session.staffLoading = false;
      })

      .addCase(actions.category, (state, { payload }) => {
        state.pureCategories = payload;
      })
      .addCase(actions.services.fetch, (state) => {
        state.categories = [];
      })
      .addCase(actions.services.success, (state, { payload }) => {
        state.categories = state.pureCategories.map((o) => ({
          id: o.id?.toString(),
          name: o.categoryName,
          code: o.code,
          services: payload.filter(s => s.catId === o.id).map(s => ({
            cateId: o.id?.toString(),
            id: s.id?.toString(),
            image: s.urlImage,
            name: s.serviceName,
            duration: s.duration,
            price: s.price,
            needCallShop: CATEGORY_CODE_NEED_CALL_SHOP.includes(o.code || ''),
          }) as IServiceUI),
        })).filter(o => o.services.length > 0) as ICategoryUI[] || [];
      })

      .addCase(actions.getTransactionDetail.fetch, (state) => {
        state.transactionDetail.data = null;
        state.transactionDetail.loading = true;
      })
      .addCase(actions.getTransactionDetail.success, (state, { payload }) => {
        state.transactionDetail.data = payload;
        state.transactionDetail.loading = false;
      })
      .addCase(actions.getTransactionDetail.fail, (state) => {
        state.transactionDetail.loading = false;
      })
      .addCase(actions.detail.success, (state, { payload }) => {
        state.detail = payload;
      })
      .addCase(actions.setSuccessData, (state, { payload }) => {
        state.successBooking = payload;
      })

      ;
  },
});
const aptServiceReducer = Slice.reducer;
export default aptServiceReducer;
